export const ORDER_BY_UPDATE = 'ORDER_BY_UPDATE';
export const ORDER_BY_CLEAR = 'ORDER_BY_CLEAR';

export const orderByInitialState = { field: '', type: '' };

export function clearOrderAction() {
  return { type: ORDER_BY_CLEAR };
}

export function updateOrderByAction({ field, type = 'ASC' }) {
  return (dispatch) => {
    dispatch({ type: ORDER_BY_UPDATE, order: { field, type } });
  };
}

export default function orderByReducer(state = orderByInitialState, action) {
  switch (action.type) {
    case ORDER_BY_UPDATE:
      return { ...state, ...action.order };
    case ORDER_BY_CLEAR:
      return { ...orderByInitialState };
    default:
      return state;
  }
}
